/**
 * Setup essential data structure needed by all modules
 */

export const bam = window.bam = {};

const url = new URL(document.location.href);

if (url.pathname !== '/') { location.href = 'notfound.html'; }
console.log("debug=", url.searchParams.get("debug"));